import { useAuth0 } from '@auth0/auth0-react';
import DeleteIcon from '@mui/icons-material/Delete';
import {
    Alert,
    Backdrop,
    Box,
    Button,
    Checkbox,
    CircularProgress,
    Fade,
    Modal,
    Paper,
    Select,
    styled,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
    Fab,
    Stack,
    Skeleton,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import LicenceInformation from './LicenceInformation';
import sendNotification from '../../utils/sendNotification';

const StyledTableContainer = styled(TableContainer)(() => ({
    marginTop: 20,
    marginBottom: 20,
}));

const StyledLabel = styled('label')(() => ({
    margin: 0,
}));

const HiddenInput = styled('input')(() => ({
    display: 'none',
}));

const BookingButton = styled(Button)(({ theme }) => ({
    padding: '10px',
    margin: '10px auto',
    borderRadius: '30px',
}));

const ModalPaper = styled(Paper)(({ theme }) => ({
    position: 'absolute',
    backgroundColor: '-linear-gradient(left, grey 25%, white 75%)',
    borderRadius: '20px',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    padding: '20px',
    minWidth: '250px',
    boxShadow: theme.shadows[5],
}));

const UploadSection = props => {
    const { getAccessTokenSilently } = useAuth0();

    const [state, setState] = useState({
        uploadingDocs: false,
    });
    const [documents, setDocuments] = useState({});
    const [uploadedDocuments, setUploadedDocuments] = useState({
        documents: [],
        loaded: false,
    });
    const [documentMetaData, setDocumentMetaData] = useState([]);
    const [fileTypeWarning, setFileTypeWarning] = useState('');
    const [licenceOpen, setLicenceOpen] = useState(false);

    const [uploadOpen, setUploadOpen] = useState(false);
    const [pendingUpload, setPendingUpload] = useState(true);

    const fileVerifier = type => {
        return !!(
            type === 'image/jpeg' ||
            type === 'image/png' ||
            type === 'image/jpg' ||
            type === 'image/webp' ||
            type === 'application/pdf'
        );
    };

    const fileSelectHandler = event => {
        console.log(event.target.files.length);
        let filesAreOk = true;
        let tempMetaData = [];
        for (const document of event.target.files) {
            if (fileVerifier(document.type)) {
                console.log(document.name, ' is a supported type');
                tempMetaData.push({
                    typeOfItem: 'Other',
                    name: document.name,
                    type: document.type,
                    size: document.size,
                    viewable: true,
                    description: '',
                });
            } else {
                filesAreOk = false;
            }
        }
        if (filesAreOk) {
            setFileTypeWarning('');
            setDocumentMetaData(tempMetaData);
            setDocuments(event.target.files);
        } else {
            setFileTypeWarning(
                'You can only upload images and pdf, please remove the unsupported filetype'
            );
            setDocuments({});
        }
    };

    const handleLicenceClose = () => {
        setLicenceOpen(false);
    };
    useEffect(() => {
        if (uploadOpen) {
            if (
                typeof documents.length !== 'undefined' ||
                documents.length > 0
            ) {
                setPendingUpload(true);
            } else {
                setPendingUpload(false);
            }
        }
    }, [uploadOpen, documents]);

    useEffect(() => {
        async function getUserDocuments() {
            const token = await getAccessTokenSilently({
                scope: process.env.REACT_APP_scope,
            });
            const documents = await axios.get('/getMyDocuments', {
                baseURL: process.env.REACT_APP_API_GATEWAY,
                url: `/getMyDocuments`,
                timeout: 30000,
                headers: {
                    authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            console.log('documents', documents.data.Message.Data);
            setUploadedDocuments({
                documents: documents.data.Message.Data,
                loaded: true,
            });
        }
        getUserDocuments();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // function handleDeleteAlertClose(event, reason) {
    //     if (reason === 'clickaway') {
    //         return;
    //     }
    // }

    const handleDelete = async (e, doc) => {
        try {
            const documents = uploadedDocuments.documents.map(docu => {
                if (docu.url === doc.url) {
                    docu.load = true;
                }
                return docu;
            });
            setUploadedDocuments({
                ...uploadedDocuments,
                documents: documents,
            });
            const token = await getAccessTokenSilently({
                scope: process.env.REACT_APP_scope,
            });
            console.log('doc', doc);
            console.log('base url', process.env.REACT_APP_API_GATEWAY);
            const response = await axios.delete(
                `${process.env.REACT_APP_API_GATEWAY}/deleteDocument`,
                {
                    timeout: 3000,
                    headers: {
                        authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    data: doc,
                }
            );
            console.log('response', response);
            if (response.status === 200) {
                let newUploadedDocuments = [];
                let interimUploadedDocs = uploadedDocuments;
                for (const document of uploadedDocuments.documents) {
                    console.log('Document', document);
                    if (document.url !== doc.url) {
                        newUploadedDocuments.push(document);
                    }
                }
                console.log('new uploaded', newUploadedDocuments);
                interimUploadedDocs.documents = newUploadedDocuments;
                setUploadedDocuments(interimUploadedDocs);
                console.log('Uploaded Documents', uploadedDocuments);
            } else {
                console.log('Error deleting document');
                sendNotification('error', 3000, 'Error deleting document');
            }
        } catch (err) {
            sendNotification(
                'error',
                3000,
                'Error deleting file, please refresh the page!'
            );
            console.log(err);
        } finally {
            setState({ ...state });
        }
    };

    function showUploads() {
        let images = [];
        for (let i = 0; i < documents.length; i++) {
            images.push({
                name: documents[i].name,
                size: documents[i].size,
                type: documents[i].type,
            });
        }
        return images;
    }

    function handleChange(event) {
        console.log(event.target.nodeName);
        console.log(event.target.localName);
        console.log(event.target.id);
        console.log(event.target.value);
        console.log(event.target.parentElement.parentElement.id);
        console.log(event.target.type);
        //Check the type of input to determine where to add the data
        if (event.target.localName === 'select') {
            //Check if the metadata already exists and to update it, or if its new and to insert it
            if (typeof documentMetaData[event.target.id] !== 'undefined') {
                var tempState = documentMetaData[event.target.id];
                tempState.typeOfItem = event.target.value;
                tempState.name = event.target.parentElement.parentElement.id;
                setDocumentMetaData({
                    ...documentMetaData,
                    [event.target.id]: tempState,
                });
            } else {
                setDocumentMetaData({
                    ...documentMetaData,
                    [event.target.id]: {
                        typeOfItem: event.target.value,
                        name: event.target.parentElement.parentElement.id,
                    },
                });
            }
        } else if (event.target.localName === 'input') {
            console.log('target checked', event.target.checked);
            console.log('target value', event.target.value);
            if (event.target.type === 'checkbox') {
                if (typeof documentMetaData[event.target.id] !== 'undefined') {
                    var tempState2 = documentMetaData[event.target.id];
                    tempState2.viewable = event.target.checked;
                    tempState2.name =
                        event.target.parentElement.parentElement.id;
                    setDocumentMetaData({
                        ...documentMetaData,
                        [event.target.id]: tempState2,
                    });
                } else {
                    setDocumentMetaData({
                        ...documentMetaData,
                        [event.target.id]: {
                            viewable: event.target.checked,
                            name: event.target.parentElement.parentElement.id,
                        },
                    });
                }
            } else if (event.target.type === 'text') {
                if (typeof documentMetaData[event.target.id] !== 'undefined') {
                    var tempState3 = documentMetaData[event.target.id];
                    tempState3.description = event.target.value;
                    tempState3.name =
                        event.target.parentElement.parentElement.parentElement.id;
                    setDocumentMetaData({
                        ...documentMetaData,
                        [event.target.id]: tempState3,
                    });
                } else {
                    setDocumentMetaData({
                        ...documentMetaData,
                        [event.target.id]: {
                            description: event.target.value,
                            name: event.target.parentElement.parentElement
                                .parentElement.id,
                        },
                    });
                }
            }
        }
    }

    const handleSubmission = async () => {
        try {
            // if (documentMetaData.length !== documents.length) {
            //     throw new Error('Metadata not selected');
            // }
            const token = await getAccessTokenSilently({
                scope: process.env.REACT_APP_scope,
            });
            setState({
                ...state,
                uploadingDocs: true,
            });

            try {
                for (let i = 0; i < documents.length; i++) {
                    let typeOfItem = 'Other';
                    let viewable = true;
                    if (fileVerifier(documents[i].type)) {
                        console.log(documents[i].name, ' is a supported type');
                    } else {
                        setFileTypeWarning(
                            'You can only upload images and pdf'
                        );
                        throw new Error(
                            `${documents[i].type} not supported file type`
                        );
                    }
                    if (typeof documentMetaData[i].typeOfItem !== 'undefined') {
                        typeOfItem = documentMetaData[i].typeOfItem;
                    }
                    let description = typeOfItem;
                    if (typeof documentMetaData[i].viewable !== 'undefined') {
                        viewable = documentMetaData[i].viewable;
                    }
                    if (
                        typeof documentMetaData[i].description !== 'undefined'
                    ) {
                        description = documentMetaData[i].description;
                    }
                    if (documents[i].name !== documentMetaData[i].name) {
                        throw new Error('Order of documents not the same');
                    }
                    if (props.type === 'school') typeOfItem = 'Presign';
                    const document = {
                        filename: documents[i].name,
                        type: typeOfItem,
                        viewable: viewable,
                        size: documents[i].size,
                        filetype: documents[i].type,
                        description: description,
                    };
                    console.log('document, ', document);
                    const permission = await axios.post(
                        '/uploadDocumentPermissionsAdvanced',
                        document,
                        {
                            baseURL: process.env.REACT_APP_API_GATEWAY,
                            timeout: 30000,
                            headers: {
                                authorization: `Bearer ${token}`,
                            },
                        }
                    );
                    console.log('Permission', JSON.stringify(permission));
                    const headers = {
                        'Content-Type': documents[i].type,
                    };

                    let interimUploadedDocs = uploadedDocuments;
                    console.log('interim ', interimUploadedDocs);
                    interimUploadedDocs.documents.push({
                        size: documents[i].size,
                        date: Date.now(),
                        sk1: permission.data.sk1,
                        filetype: documents[i].type,
                        url: permission.data.photoFilename,
                        schoolCanView: viewable,
                        description: description,
                    });
                    setUploadedDocuments(interimUploadedDocs);

                    console.log(JSON.stringify(permission));
                    axios.put(permission.data.uploadURL, documents[i], {
                        timeout: 15000,
                        headers: headers,
                    });
                }
            } finally {
                setDocuments({});
                setDocumentMetaData({});
                props.setNotif('success', 6000, 'Documents uploaded');
                setUploadOpen(false);
            }
        } catch (err) {
            if (err.response && err.response.data && err.response.data.error) {
                props.setNotif(
                    'error',
                    0,
                    `Upload Failed: ${err.response.data.error}`
                );
            } else {
                props.setNotif('error', 0, 'Upload Failed');
            }
        } finally {
            setState({
                ...state,
                uploadingDocs: false,
            });
            setUploadOpen(false);
        }
    };
    const ListSkeleton = ({ listsToRender }) => {
        return (
            <div>
                {Array(listsToRender)
                    .fill(1)
                    .map(index => (
                        <Skeleton
                            height={72}
                            animation="wave"
                            sx={{ margin: '0px 16px' }}
                        />
                    ))}
            </div>
        );
    };
    return (
        <Box sx={{ width: '97%', margin: '0px auto 0', textAlign: 'left' }}>
            <Box>
                <div>
                    <Modal
                        open={uploadOpen}
                        onClose={() => {
                            setUploadOpen(false);
                        }}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500,
                        }}
                    >
                        <Fade in={uploadOpen}>
                            <ModalPaper
                                id="ModalBoxComponent"
                                sx={{
                                    width: '95%',
                                }}
                            >
                                <div>
                                    <Typography variant="h6" component="h2">
                                        Pending file upload
                                    </Typography>
                                    {fileTypeWarning !== '' && (
                                        <Alert severity="error">
                                            {fileTypeWarning}
                                        </Alert>
                                    )}
                                    <IconButton
                                        aria-label="close"
                                        onClick={() => {
                                            setUploadOpen(false);
                                        }}
                                        sx={{
                                            position: 'absolute',
                                            right: 8,
                                            top: 8,
                                            color: theme =>
                                                theme.palette.grey[500],
                                        }}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                </div>

                                <br />
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <HiddenInput
                                        id="contained-button-file"
                                        multiple
                                        type="file"
                                        onChange={fileSelectHandler}
                                        data-cy="choose-files"
                                    />
                                    <StyledLabel htmlFor="contained-button-file">
                                        <BookingButton
                                            color="secondary"
                                            variant="contained"
                                            component="span"
                                            sx={{ borderRadius: '4px' }}
                                        >
                                            {props.type === 'teacher'
                                                ? 'Upload profile documents'
                                                : 'Upload pre-work authorisation documents'}
                                        </BookingButton>
                                    </StyledLabel>
                                </Box>
                                <StyledTableContainer
                                    component={Paper}
                                    elevation={3}
                                    sx={{ maxHeight: '48vh' }}
                                >
                                    <Table
                                        stickyHeader
                                        aria-label="simple table"
                                        id="pre-upload"
                                        data-cy="table-pre-upload"
                                    >
                                        {documents && (
                                            <>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="left">
                                                            Filename
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            Size
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            File Type
                                                        </TableCell>
                                                        {props.type ===
                                                            'teacher' && (
                                                            <>
                                                                <TableCell align="left">
                                                                    School can
                                                                    view
                                                                </TableCell>
                                                                <TableCell align="left">
                                                                    Document
                                                                    Type
                                                                </TableCell>
                                                            </>
                                                        )}
                                                        <TableCell align="left">
                                                            Description
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {showUploads().map(
                                                        (upload, index) => {
                                                            return (
                                                                <TableRow
                                                                    key={
                                                                        upload.name
                                                                    }
                                                                >
                                                                    <TableCell
                                                                        component="th"
                                                                        scope="row"
                                                                        data-cy="filename"
                                                                    >
                                                                        {
                                                                            upload.name
                                                                        }
                                                                    </TableCell>
                                                                    <TableCell align="left">
                                                                        {upload.size /
                                                                            1000}
                                                                        kb
                                                                    </TableCell>
                                                                    <TableCell
                                                                        align="left"
                                                                        data-cy="filetype"
                                                                    >
                                                                        {
                                                                            upload.type
                                                                        }
                                                                    </TableCell>
                                                                    {props.type ===
                                                                        'teacher' && (
                                                                        <>
                                                                            <TableCell
                                                                                align="left"
                                                                                id={
                                                                                    upload.name
                                                                                }
                                                                            >
                                                                                <Checkbox
                                                                                    defaultChecked
                                                                                    onChange={
                                                                                        handleChange
                                                                                    }
                                                                                    id={
                                                                                        index
                                                                                    }
                                                                                />
                                                                            </TableCell>
                                                                            <TableCell
                                                                                align="left"
                                                                                id={
                                                                                    upload.name
                                                                                }
                                                                            >
                                                                                <Select
                                                                                    data-cy="document-type"
                                                                                    native
                                                                                    id={
                                                                                        index
                                                                                    }
                                                                                    defaultValue="Other"
                                                                                    value={
                                                                                        state[
                                                                                            upload
                                                                                                .name
                                                                                        ] &&
                                                                                        state[
                                                                                            upload
                                                                                                .name
                                                                                        ]
                                                                                            .value
                                                                                    }
                                                                                    onChange={
                                                                                        handleChange
                                                                                    }
                                                                                >
                                                                                    <option
                                                                                        aria-label="None"
                                                                                        value=""
                                                                                    />
                                                                                    <option value="Firstaid">
                                                                                        First
                                                                                        Aid
                                                                                        Certificate
                                                                                    </option>
                                                                                    <option value="Cpr">
                                                                                        CPR
                                                                                        Certificate
                                                                                    </option>
                                                                                    <option value="Anaphylaxis">
                                                                                        Anaphylaxis
                                                                                    </option>
                                                                                    <option value="Asthma">
                                                                                        Asthma
                                                                                    </option>
                                                                                    <option value="Resume">
                                                                                        Resume
                                                                                    </option>
                                                                                    <option value="Other">
                                                                                        Other
                                                                                    </option>
                                                                                </Select>
                                                                            </TableCell>
                                                                        </>
                                                                    )}
                                                                    <TableCell
                                                                        id={
                                                                            upload.name
                                                                        }
                                                                    >
                                                                        <TextField
                                                                            data-cy="description"
                                                                            onChange={
                                                                                handleChange
                                                                            }
                                                                            id={
                                                                                index
                                                                            }
                                                                            label="Extra Information"
                                                                            type="text"
                                                                        ></TextField>
                                                                    </TableCell>
                                                                </TableRow>
                                                            );
                                                        }
                                                    )}
                                                    {/* // <Box>
                                //     {documents.documents.filter(
                                //         document => {
                                //             return (
                                //                 <h1>
                                //                     document
                                //                 </h1>
                                //             );
                                //         }
                                //     )}
                                // </Box> */}
                                                </TableBody>
                                            </>
                                        )}

                                        {!documents && (
                                            <>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="left">
                                                            Filename
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            Size
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            Type
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell>
                                                            No documents
                                                            uploaded
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </>
                                        )}
                                    </Table>
                                </StyledTableContainer>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        textAlign: 'right',
                                    }}
                                >
                                    <BookingButton
                                        disabled
                                        sx={{ marginX: '0px' }}
                                    >
                                        {state.uploadingDocs === true && (
                                            <Typography color="primary">
                                                Uploading...
                                            </Typography>
                                        )}
                                        {!documents && (
                                            <Typography color="secondary">
                                                No files selected.
                                            </Typography>
                                        )}
                                    </BookingButton>
                                    <BookingButton
                                        disabled={pendingUpload ? false : true}
                                        data-cy="submit-docs"
                                        color="primary"
                                        variant="contained"
                                        sx={{
                                            borderRadius: '4px',
                                            textAlign: 'right',
                                            margin: 'auto 10px auto 0px',
                                        }}
                                        component="span"
                                        onClick={handleSubmission}
                                    >
                                        Submit Documents
                                    </BookingButton>
                                </Box>
                            </ModalPaper>
                        </Fade>
                    </Modal>
                </div>
            </Box>
            <Box>
                <Stack direction="row">
                    <Typography variant="h5" sx={{ m: 2 }}>
                        {props.type === 'teacher'
                            ? 'Your Documents'
                            : 'Pre-work Authorisation Documents'}
                    </Typography>
                    <Fab
                        sx={{ zIndex: 39 }}
                        color="primary"
                        aria-label="add"
                        data-cy="open-upload-modal"
                        onClick={() => setUploadOpen(true)}
                        sx={{ zIndex: 3 }}
                    >
                        <AddIcon />
                    </Fab>
                </Stack>
                {props.type === 'school' && (
                    <Typography variant="body1" sx={{ m: 2 }}>
                        Documents in this section require a teacher to sign
                        before accepting a shift
                    </Typography>
                )}

                <StyledTableContainer component={Paper}>
                    <Table
                        aria-label="simple table"
                        id="uploaded"
                        data-cy="table-uploaded"
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell align="left">Filename</TableCell>
                                <TableCell align="left">Size</TableCell>
                                <TableCell align="left">File Type</TableCell>
                                {props.type === 'teacher' && (
                                    <>
                                        <TableCell align="left">
                                            School can view
                                        </TableCell>
                                        <TableCell align="left">
                                            Document Type
                                        </TableCell>
                                    </>
                                )}
                                <TableCell align="left">Description</TableCell>
                                <TableCell align="left"></TableCell>
                            </TableRow>
                        </TableHead>
                        {uploadedDocuments.loaded && (
                            <TableBody>
                                {uploadedDocuments.documents.length === 0 ? (
                                    <TableRow key={0}>
                                        <TableCell>
                                            <Typography>
                                                No Documents Uploaded
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    uploadedDocuments.documents.map(
                                        (doc, index) => {
                                            return (
                                                <TableRow key={index}>
                                                    <TableCell
                                                        component="th"
                                                        scope="row"
                                                        data-cy="filename"
                                                    >
                                                        {
                                                            RegExp(
                                                                '^(?:[^_]*_)?(.+)'
                                                            ).exec(doc.url)[1]
                                                        }
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        <Typography noWrap>
                                                            {(
                                                                doc.size /
                                                                1000000
                                                            ).toFixed(2)}{' '}
                                                            MB
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell
                                                        align="left"
                                                        data-cy="filetype"
                                                    >
                                                        {doc.filetype}
                                                    </TableCell>
                                                    {props.type ===
                                                        'teacher' && (
                                                        <>
                                                            <TableCell
                                                                align="left"
                                                                id={doc.url}
                                                            >
                                                                <Checkbox
                                                                    defaultChecked
                                                                    checked={
                                                                        doc.schoolCanView
                                                                    }
                                                                    id={index}
                                                                    disabled
                                                                />
                                                            </TableCell>
                                                            <TableCell
                                                                align="left"
                                                                id={doc.url}
                                                                data-cy="doc-type"
                                                            >
                                                                <Typography>
                                                                    {
                                                                        /[A-Za-z]+/.exec(
                                                                            doc.sk1
                                                                        )[0]
                                                                    }
                                                                </Typography>
                                                            </TableCell>
                                                        </>
                                                    )}
                                                    <TableCell
                                                        align="left"
                                                        id={doc.url}
                                                        data-cy="description"
                                                    >
                                                        <Typography>
                                                            {doc.description}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell
                                                        align="left"
                                                        id={doc.url}
                                                    >
                                                        <IconButton
                                                            aria-label="delete"
                                                            data-cy="delete-doc"
                                                            onClick={e => {
                                                                handleDelete(
                                                                    e,
                                                                    doc
                                                                );
                                                            }}
                                                        >
                                                            <DeleteIcon />
                                                            {doc.load && (
                                                                <CircularProgress
                                                                    size="3rem"
                                                                    sx={{
                                                                        position:
                                                                            'absolute',
                                                                    }}
                                                                />
                                                            )}
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        }
                                    )
                                )}

                                {/* // <Box>
                        //     {documents.documents.filter(
                        //         document => {
                        //             return (
                        //                 <h1>
                        //                     document
                        //                 </h1>
                        //             );
                        //         }
                        //     )}
                        // </Box> */}
                            </TableBody>
                        )}

                        {/*!documents && (
                          //<>
                          //    <TableHead>
                          //        <TableRow>
                          //            <TableCell align="left">
                          //                Filename
                          //            </TableCell>
                          //           <TableCell align="left">Size</TableCell>
                          //            <TableCell align="left">Type</TableCell>
                          //        </TableRow>
                          //    </TableHead>
                          //   <TableBody>
                          //       <TableRow>
                          //           <TableCell>
                          //               No documents uploaded
                          //           </TableCell>
                          //      </TableRow>
                          //  </TableBody>
                          //</>
                      )*/}
                    </Table>

                    {!uploadedDocuments.loaded ||
                        (state.uploadingDocs && (
                            <ListSkeleton listsToRender={documents.length} />
                        ))}
                </StyledTableContainer>
                {props.type === 'teacher' && (
                    <>
                        <BookingButton
                            variant="outlined"
                            onClick={() => {
                                setLicenceOpen(true);
                            }}
                        >
                            Add Licence
                        </BookingButton>
                        <Modal
                            open={licenceOpen}
                            onClose={handleLicenceClose}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                            closeAfterTransition
                            BackdropComponent={Backdrop}
                            BackdropProps={{
                                timeout: 500,
                            }}
                        >
                            <Fade in={licenceOpen}>
                                <ModalPaper id="ModalBoxComponent">
                                    <Box>
                                        <LicenceInformation
                                            clickNextButton={handleLicenceClose}
                                            title="Teacher Licence Information"
                                            type="teacherId"
                                            name="Teacher"
                                            stringLength={1}
                                            nextButton={false}
                                            ext={false}
                                        />
                                    </Box>
                                </ModalPaper>
                            </Fade>
                        </Modal>
                    </>
                )}
            </Box>
        </Box>
    );
};

export default UploadSection;
